import name from './name'

const selectSliceData = state => state[name]
const selectAuthors = state => selectSliceData(state).authors
const selectLoaded = state => selectSliceData(state).loaded

export {
  selectAuthors,
  selectLoaded
}
